export default {"src":"/_next/static/media/img_logo.419bcc5d.svg","height":47,"width":157,"blurWidth":0,"blurHeight":0};